import React from 'react';
import { Calculator, Phone, Mail, Send, MapPin } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLang();
  return <footer className="bg-white text-black py-16 border-t border-neutral-100" data-id="element-147">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl" data-id="element-148">
        <div className="grid md:grid-cols-4 gap-12 mb-16" data-id="element-149">
          <div className="col-span-1 md:col-span-2" data-id="element-150">
            <div className="flex items-center gap-3 mb-6" data-id="element-151">
              <Calculator className="h-6 w-6 text-black" data-id="element-152" />
              <span className="font-bold text-xl tracking-tight" data-id="element-153">
                Księgowość
              </span>
            </div>
            <p className="text-sm text-neutral-500 leading-relaxed max-w-xs mb-8" data-id="element-154">
              {t('footer_desc')}
            </p>

            <div className="flex flex-col gap-3" data-id="element-155">
              <a href="tel:+48220000000" className="flex items-center gap-2 text-sm text-neutral-600 hover:text-black transition-colors group" data-id="element-156">
                <Phone className="h-4 w-4 group-hover:animate-pulse" data-id="element-157" />
                +48 22 000 00 00
              </a>
              <a href="https://t.me/ksiegowosc_pl" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-neutral-600 hover:text-black transition-colors group" data-id="element-158">
                <Send className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" data-id="element-159" />
                @ksiegowosc_pl
              </a>
              <a href="mailto:info@ksiegowosc.pl" className="flex items-center gap-2 text-sm text-neutral-600 hover:text-black transition-colors" data-id="element-160">
                <Mail className="h-4 w-4" data-id="element-161" />
                info@ksiegowosc.pl
              </a>
              <div className="flex items-center gap-2 text-sm text-neutral-600" data-id="element-162">
                <MapPin className="h-4 w-4 flex-shrink-0" data-id="element-163" />
                ul. Marszałkowska 111, Warszawa
              </div>
            </div>
          </div>

          <div data-id="element-164">
            <h4 className="font-bold mb-6 text-sm uppercase tracking-wider" data-id="element-165">
              {t('footer_nav_title')}
            </h4>
            <ul className="space-y-3 text-sm text-neutral-500" data-id="element-166">
              <li data-id="element-167">
                <a href="#about" className="hover:text-black transition-colors hover:translate-x-1 inline-block" data-id="element-168">
                  {t('nav_about')}
                </a>
              </li>
              <li data-id="element-169">
                <a href="#services" className="hover:text-black transition-colors hover:translate-x-1 inline-block" data-id="element-170">
                  {t('nav_services')}
                </a>
              </li>
              <li data-id="element-171">
                <a href="#why-us" className="hover:text-black transition-colors hover:translate-x-1 inline-block" data-id="element-172">
                  {t('nav_advantages')}
                </a>
              </li>
              <li data-id="element-173">
                <a href="#faq" className="hover:text-black transition-colors hover:translate-x-1 inline-block" data-id="element-174">
                  {t('nav_faq')}
                </a>
              </li>
              <li data-id="element-175">
                <a href="#contact" className="hover:text-black transition-colors hover:translate-x-1 inline-block" data-id="element-176">
                  {t('nav_contacts')}
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-177">
            <h4 className="font-bold mb-6 text-sm uppercase tracking-wider" data-id="element-178">
              {t('footer_contacts_title')}
            </h4>
            <ul className="space-y-3 text-sm text-neutral-500" data-id="element-179">
              <li data-id="element-180">
                <a href="tel:+48220000000" className="hover:text-black transition-colors" data-id="element-181">
                  +48 22 000 00 00
                </a>
              </li>
              <li data-id="element-182">
                <a href="mailto:info@ksiegowosc.pl" className="hover:text-black transition-colors" data-id="element-183">
                  info@ksiegowosc.pl
                </a>
              </li>
              <li data-id="element-184">ul. Marszałkowska 111, Warszawa</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-neutral-100 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-neutral-400" data-id="element-185">
          <p data-id="element-186">
            © {new Date().getFullYear()} Księgowość. {t('footer_rights')}
          </p>
          <div className="flex gap-8" data-id="element-187">
            <a href="#" className="hover:text-black transition-colors" data-id="element-188">
              {t('footer_privacy')}
            </a>
            <a href="#" className="hover:text-black transition-colors" data-id="element-189">
              {t('footer_terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}